import { hideElement, isIframe, setReadOpacityForElementsById, showElement } from "./helper";

import contentTracker from "./InhaltGelesen";

document.addEventListener('DOMContentLoaded', markDownloadsAsRead);
document.addEventListener('htmx:afterSettle', markDownloadsAsRead);

document.addEventListener('DOMContentLoaded', addDownloadReadClickEvents);
document.addEventListener('htmx:afterSettle', addDownloadReadClickEvents);

document.addEventListener('DOMContentLoaded', readCurrentDownload);
document.addEventListener('htmx:afterSettle', readCurrentDownload);

// Page navigation vor/zurück knopf Artikel markieren
window.addEventListener('pageshow', (event) => {
    if (event.eventPhase == 2 && String(window.performance.getEntriesByType("navigation")[0].type) == "back_forward") {
        markDownloadsAsRead();
    }
});

function readCurrentDownload() {
    const downloadDetail = document.querySelector(`[id^="download_detail_"]`);
    if (downloadDetail && !isIframe()) {
        const parts = downloadDetail.id.split('_');
        const download_id = parts[parts.length - 1];
        contentTracker.setContentStatus(download_id, "download", true);
    }
}

function markDownloadsAsRead() {
    contentTracker.getContentIDsReadByType("download").then(downloads_read => {
        if (downloads_read == null) { return; }

        markDownloadTeasersAsRead(downloads_read);
    });
}

function markDownloadTeasersAsRead(download_ids) {
    setReadOpacityForElementsById(download_ids.map((element) => "download_teaser_" + element), true);
    showElement(download_ids.map((element) => "button_download_teaser_not_read_" + element));
    hideElement(download_ids.map((element) => "button_download_teaser_read_" + element));
}

function markDownloadTeaserAsUnread(artikel_id) {
    setReadOpacityForElementsById(["download_teaser_" + artikel_id], false);
    hideElement(["button_download_teaser_not_read_" + artikel_id]);
    showElement(["button_download_teaser_read_" + artikel_id]);
}


function addDownloadReadClickEvents() {
    const links = document.querySelectorAll(`[id^="button_download_teaser_read_"]`);
    links.forEach(function (link) {
        link.addEventListener('click', function () {
            const parts = link.id.split('_');
            const download_id = parts[parts.length - 1];
            markDownloadTeasersAsRead([download_id]);
            contentTracker.setContentStatus(download_id, "download", true);
        });
    });

    const links_unread = document.querySelectorAll(`[id^="button_download_teaser_not_read_"]`);
    links_unread.forEach(function (link) {
        link.addEventListener('click', function () {
            const parts = link.id.split('_');
            const download_id = parts[parts.length - 1];
            markDownloadTeaserAsUnread(download_id);
            contentTracker.setContentStatus(download_id, "download", false);
        });
    });
}
